import { Box } from "@mui/material";
import HistoricoAlteracoesTable from "../../../../Table/HistoricoAlteracoesTable";

const HistoricoAlteracoesAba = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <HistoricoAlteracoesTable
        produtoRetorno="Agente do Corretor"
        pessoaRespondida="Clientes"
      />
    </Box>
  );
};

export default HistoricoAlteracoesAba;
